import "_style/emoji.css"
var Emoji = (function () {
  function Emoji () {
    this.preloadEmojiImage()
    this.html = ''
  }
  Emoji.prototype = {
    constructor: Emoji,
    hasEmoji: function (text) {
      var result = text.match(/data-emoji/gi)
      if (result && result.length > 0) {
        return true
      }
      return false
    },
    replaceEmojiByName: function (text) {
      var _this = this
      var str = text.replace(/\[(cube_.*?)\]/gi, function (emoji, key) {
        return '<span data-emoji="' + key + '" class="' + _this.getEmojiFullClassName(key) + '"></span>'
      })
      str = str.replace(/\[(heygirl_.*?)\]/gi, function (emoji, key) {
        return '<span data-emoji="' + key + '" class="' + _this.getEmojiFullClassName(key) + '"></span>'
      })
      return str
    },
    replaceEmoji: function (html) {
      var div = document.createElement('div')
      div.innerHTML = this.transformHTML(html)
      var emojis = div.querySelectorAll('.hb-emoji')
      if (emojis && emojis.length > 0) {
        for (var i=0; i<emojis.length; i++) {
          this.emojiHandler(emojis[i])
        }
      }
      return div.innerHTML
    },
    emojiHandler: function (emoji) {
      var emoji_fullname = emoji.getAttribute('data-emoji')

      emoji.className = this.getEmojiFullClassName(emoji_fullname)
    },
    getEmojiFullClassName: function (emoji_fullname) {
      var className = ''
      var emoji_package = emoji_fullname.split('_')[0]
      var emoji_name = emoji_fullname.split('_')[1]
      for (var i=0; i<this.emojis.length; i++) {
        if (this.emojis[i].package_name !== emoji_package) {
          continue
        }
        var list = this.emojis[i].list
        for (var j=0; j<list.length; j++) {
          if (list[j].name !== emoji_name) {
            continue;
          }
          className = 'hb-emoji hb-emoji-' + emoji_package + ' ' + list[j].class
          break;
        }
        break;
      }
      return className
    },
    preloadEmojiImage: function () {
      var emoji_list = [
        'https://static.max-c.com/heybox_web/emoji/cube/cube_emoji_v3.png',
        'https://cdn.max-c.com/heybox_web/emoji/cube2/cube2_emoji.png'
      ]
      var img = document.createElement('img')
      for(var i=0; i<emoji_list.length;i++) {
        img.src = emoji_list[i]
      }
      img = null
    },
    getHtmlFromDom: function (dom) {
      return dom.innerHTML
    },
    transformHTML: function (html) {
      var arrEntities = {'lt':'<','gt':'>','nbsp':' ','amp':'&','quot':'"'};
      return html.replace(/&(lt|gt|nbsp|amp|quot);/ig, function(all,t){return arrEntities[t];})
    },
    emojis: [
      {
        package_name: 'heygirl',
        list: [
          {name: '诶嘿', class: 'hb-emoji-heygirl_11'},
          {name: '哭', class: 'hb-emoji-heygirl_12'},
          {name: '白嫖怪', class: 'hb-emoji-heygirl_13'},
          {name: '疑问', class: 'hb-emoji-heygirl_14'},
          {name: '痴', class: 'hb-emoji-heygirl_15'},
          {name: '喜欢', class: 'hb-emoji-heygirl_16'},
          {name: '捏脸', class: 'hb-emoji-heygirl_21'},
          {name: '害羞', class: 'hb-emoji-heygirl_22'},
          {name: '苦酒入喉', class: 'hb-emoji-heygirl_23'},
          {name: '秃', class: 'hb-emoji-heygirl_24'},
          {name: 'rua!', class: 'hb-emoji-heygirl_25'},
          {name: '吃瓜', class: 'hb-emoji-heygirl_26'},
          {name: '茄化', class: 'hb-emoji-heygirl_31'},
          {name: '无语', class: 'hb-emoji-heygirl_32'},
          {name: '这…', class: 'hb-emoji-heygirl_33'},
          {name: '敲开心', class: 'hb-emoji-heygirl_34'},
          {name: '开可乐', class: 'hb-emoji-heygirl_35'},
          {name: '哈哈', class: 'hb-emoji-heygirl_36'},
          {name: '滑稽', class: 'hb-emoji-heygirl_41'},
          {name: '偷看', class: 'hb-emoji-heygirl_42'},
          {name: '喝奶茶', class: 'hb-emoji-heygirl_43'},
          {name: '惊', class: 'hb-emoji-heygirl_44'},
          {name: '记下来', class: 'hb-emoji-heygirl_45'},
          {name: '挨刀', class: 'hb-emoji-heygirl_46'}
        ]
      },
      {
        package_name: 'cube',
        list: [
          {name: '哭泣', class: 'hb-emoji-cube_11'},
          {name: '酷', class: 'hb-emoji-cube_12'},
          {name: 'doge', class: 'hb-emoji-cube_13'},
          {name: '喜欢', class: 'hb-emoji-cube_14'},
          {name: '黑人问号', class: 'hb-emoji-cube_15'},
          {name: '惊讶', class: 'hb-emoji-cube_16'},
          {name: '开心', class: 'hb-emoji-cube_21'},
          {name: '捂脸哭', class: 'hb-emoji-cube_22'},
          {name: '晕', class: 'hb-emoji-cube_23'},
          {name: '感动', class: 'hb-emoji-cube_24'},
          {name: '委屈', class: 'hb-emoji-cube_25'},
          {name: '并不简单', class: 'hb-emoji-cube_26'},
          {name: '乖', class: 'hb-emoji-cube_31'},
          {name: '笑cry', class: 'hb-emoji-cube_32'},
          {name: '怒', class: 'hb-emoji-cube_33'},
          {name: '滑稽', class: 'hb-emoji-cube_34'},
          {name: '沧桑', class: 'hb-emoji-cube_35'},
          {name: '凄凉', class: 'hb-emoji-cube_36'},
          {name: '赞', class: 'hb-emoji-cube_41'},
          {name: '学习', class: 'hb-emoji-cube_42'},
          {name: '叹气', class: 'hb-emoji-cube_43'},
          {name: '加油', class: 'hb-emoji-cube_44'},
          {name: '摊手', class: 'hb-emoji-cube_45'},
          {name: '喷水', class: 'hb-emoji-cube_46'},
          {name: '打脸', class: 'hb-emoji-cube_51'},
          {name: 'H币', class: 'hb-emoji-cube_52'},
          {name: '生气', class: 'hb-emoji-cube_53'},
          {name: '困', class: 'hb-emoji-cube_54'},
          {name: '闭嘴', class: 'hb-emoji-cube_55'},
          {name: '吐', class: 'hb-emoji-cube_56'},
          {name: '咕咕', class: 'hb-emoji-cube_61'},
          {name: '微笑', class: 'hb-emoji-cube_62'},
          {name: '哇', class: 'hb-emoji-cube_63'},
          {name: '汗', class: 'hb-emoji-cube_64'},
          {name: '吓', class: 'hb-emoji-cube_65'},
          {name: '睡觉', class: 'hb-emoji-cube_66'},
          {name: '2023', class: 'hb-emoji-cube_71'},
          {name: '圣诞树', class: 'hb-emoji-cube_72'},
          {name: '庆祝', class: 'hb-emoji-cube_73'},
          {name: '庆祝-圣诞', class: 'hb-emoji-cube_74'},
          {name: '你懂我', class: 'hb-emoji-cube_75'},
          {name: '我懂你', class: 'hb-emoji-cube_76'},
          {name: '阳', class: 'hb-emoji-cube_81'},
          {name: '比心', class: 'hb-emoji-cube_82'},
          {name: 'wota', class: 'hb-emoji-cube_83'},
          {name: '鹅', class: 'hb-emoji-cube_84'},
          {name: '握草', class: 'hb-emoji-cube_85'},
          {name: '这是什么鸟', class: 'hb-emoji-cube_86'},
          {name: '上学-乐', class: 'hb-emoji-cube_91'},
          {name: '上学-丧', class: 'hb-emoji-cube_92'},
          {name: '打咩', class: 'hb-emoji-cube_93'},
          {name: '超人', class: 'hb-emoji-cube_94'},
          {name: '僵尸', class: 'hb-emoji-cube_95'},
          {name: '窝囊', class: 'hb-emoji-cube_96'},
          {name: '小鸡', class: 'hb-emoji-cube_101'},
          {name: '摸摸头', class: 'hb-emoji-cube_102'},
          {name: '电牛', class: 'hb-emoji-cube_103'},
          {name: '摘墨镜', class: 'hb-emoji-cube_104'}
        ]
      }
    ]
  }

  return Emoji
})();
export default Emoji